import styles from '../../styles/components/toggleSwitch.module.css';

export default function ToggleSwitch({
  offText,
  onText,
  isChecked = false,
  onClick = () => {},
  toolTip = '',
  disabled = false
}) {
  return (
    <div className={styles.container} data-disabled={disabled}>
      <div onClick={onClick} className={styles.switch}>
        <input type='checkbox' checked={isChecked} readOnly />
        <span className={`${styles.round} ${styles.slider}`}>
          {isChecked ? (
            <span className={styles.sliderText}>{onText}</span>
          ) : (
            <span className={styles.sliderText}>{offText}</span>
          )}
        </span>
      </div>
      <span className={styles.toolTip}>{toolTip}</span>
    </div>
  );
}
